import styled from 'styled-components';

import { TextEditor, TextEditorProps } from '@components/text-editors';
import {
  ExtendedFieldMappingEditorValue,
  transformSimpleValueOutput,
} from '@components/text-editors/addons/field-mapping';
import {
  PILL_HEIGHT_PX,
  PILL_ROW_GAP_PX,
  pillRowAlignment,
} from '@components/text-editors/helpers';
import { EditorValue } from '@components/text-editors/text-editor';
import { pxToRem } from '@utils/converters';

import { insertTokenNode, Token, transformInput, tag } from './extensions';

export type TokenListFieldProps = Omit<TextEditorProps, 'defaultValue' | 'onChange'> & {
  defaultValue?: EditorValue[];
  onChange?: (value: ExtendedFieldMappingEditorValue[]) => void;
};

export const TokenListField = ({ defaultValue, onChange, ...rest }: TokenListFieldProps) => {
  return (
    <StyledEditor
      extensions={[Token.configure()]}
      plaintext
      singleLine
      onChange={(value) => onChange?.(transformSimpleValueOutput(value, tag))}
      onEditorBlur={insertTokenNode}
      defaultValue={defaultValue ? transformInput(defaultValue) : undefined}
      {...rest}
    />
  );
};

const StyledEditor = styled(TextEditor)({
  // a wrapping list of tokens: grow with content and gap the rows, like the *-list-field components
  // (horizontal inset is owned by the editor container, so only vertical/pill spacing lives here)
  '.ProseMirror': {
    lineHeight: pxToRem(PILL_HEIGHT_PX + PILL_ROW_GAP_PX),
    minHeight: pxToRem(PILL_HEIGHT_PX),
  },
  '.node-wrapper': pillRowAlignment,
});
